import React, { useEffect, useState } from "react";
import { getVideo, getYoutubeVideo } from "../api/core";
import MovieBanner from "../banner/moviebanner";
import RLandscapeSlider from "../landscapeSlider/Rlandscape";
import "../landscapeSlider/landscapeSlider.css";
import "../portraitSlider/portraitSlider.css";
import MovieTab from "../detailsTab/movieTab";
import NotFound from "../notfound/notfound";
import BoxedDetails from "../boxedDetails/boxedDetails";
import YoutubeDetails from "../boxedDetails/youtubeDetails";
import YoutubePlayer from "../boxedPlayer/youtubePlayer";
import BoxedPlayer from "../boxedPlayer/boxedPlayer";
import "../boxedPlayer/boxedPlayer.css";
import FeaturedList from "../featuredList/featureList";
import CarouselContentLoader from "../loader/contentLoader";
import Head from "../head/head";
import { useRef } from "react";
import Global from "../../global.js";
import { useTranslation } from "react-i18next";
import YoutubeList from "../featuredList/youtubeList";

const Detail = (props) => {
  const initstate = { playlist: [] };
  const [videoPlay, setVideoPlay] = useState(initstate);
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  const mounted = useRef(false);
  const { t } = useTranslation(["translation"]);
  useEffect(() => {
    mounted.current = true;
    isLoading(true);
    const PLSplaylistDetail = async (id) => {
      /* eslint-disable no-unused-vars */

      if (Global.VCMS === "YouTube") {
        const result = await getYoutubeVideo(id).then(
          (result) => {
            if (mounted.current) {
              setVideoPlay(result.data);
              isLoading(false);
            }
          },
          (error) => {
            SetError(true);
            isLoading(false);
          }
        );
      } else {
        const result = await getVideo(id).then(
          (result) => {
            if (mounted.current) {
              setVideoPlay(result.data);
              isLoading(false);
            }
          },
          (error) => {
            SetError(true);
            isLoading(false);
          }
        );
      }

      /* eslint-disable no-unused-vars */
    };

    PLSplaylistDetail(props.match.params.Id);
    return () => {
      mounted.current = false;
    };
  }, [props.match.params.Id]);

  if (
    !error &&
    !loading &&
    videoPlay.playlist !== null &&
    videoPlay.size !== 0 &&
    Global.VCMS === "JWPlayer"
  ) {
    return (
      <div>
        <Head
          title={videoPlay.playlist[0].title}
          quote={videoPlay.playlist[0].title}
          description={videoPlay.playlist[0].description}
          image={
            "https://cdn.jwplayer.com/v2/media/" +
            props.match.params.Id +
            "/poster.jpg?width=720"
          }
        ></Head>
        {videoPlay.playlist[0].MediaType !== "News" &&
        videoPlay.playlist[0].MediaType !== "News Show" &&
        videoPlay.playlist[0].MediaType !== "Live" &&
        videoPlay.playlist[0].MediaType !== "Other" ? (
          <div>
            <MovieBanner
              data={videoPlay}
              dataId={props.match.params.Id}
              newData={videoPlay}
              banData={videoPlay.playlist[0]}
              {...props}
            ></MovieBanner>
            <MovieTab
              videoId={props.match.params.Id}
              id={"related"}
              type={"movie"}
              active={"more_details"}
              data={videoPlay.playlist[0]}
              recomm={videoPlay.playlist[0].Recommendation}
              {...props}
            ></MovieTab>
          </div>
        ) : (
          <div className="demoClass">
            <div className="boxImage">
              <div className="boxOverlay">
                <div className="row">
                  <div className="col-xl-8 col-md-7 fullmax">
                    <div className="boxFull">
                      <BoxedPlayer
                        header={true}
                        videoId={videoPlay.playlist[0].mediaid}
                        videoData={videoPlay}
                        {...props}
                      ></BoxedPlayer>
                    </div>
                  </div>

                  <div className="col-xl-4 col-md-5 halfmax">
                    <FeaturedList
                      videoId={props.match.params.Id}
                      offset={1}
                      recomm={
                        Global.RVPL
                          ? Global.RVPL
                          : videoPlay.playlist[0].Recommendation
                      }
                      recom={
                        Global.RVPL
                          ? Global.RVPL
                          : videoPlay.playlist[0].Recommendation
                      }
                      app={props.match.params.AppId}
                    ></FeaturedList>
                  </div>
                </div>
              </div>
            </div>
            <div className="boxedcontainer">
              <BoxedDetails
                data={videoPlay.playlist[0]}
                {...props}
              ></BoxedDetails>
            </div>
            <div className="mt-2">
              {/* <ArticleSlider id={"broke1"} title={"Latest Articles"} description={true} news={true} tag={true}></ArticleSlider> */}

              <RLandscapeSlider
                videoId={videoPlay.playlist[0].mediaid}
                limit={20}
                offset={5}
                titleCard={true}
                recomm={videoPlay.playlist[0].Recommendation}
                recom={videoPlay.playlist[0].Recommendation}
                header={true}
                {...props}
              ></RLandscapeSlider>
            </div>
          </div>
        )}

        {/* <CrewSlider title={"Cast and Crew"} image={true} id={"castid"}></CrewSlider> */}
      </div>
    );
  } else if (
    !error &&
    !loading &&
    Global.VCMS === "YouTube" &&
    videoPlay.size !== 0 &&
    videoPlay.items.length > 0
  ) {
    return (
      <div className="demoClass">
        <div className="boxImage">
          <div className="boxOverlay">
            <div className="row">
              <div className="col-xl-8 col-md-7 fullmax">
                <div className="boxFull">
                  <YoutubePlayer
                    header={true}
                    videoId={videoPlay.items[0].id}
                    videoData={videoPlay}
                    {...props}
                  ></YoutubePlayer>
                </div>
                <div className="boxedcontainer">
                  <YoutubeDetails
                    data={videoPlay.items[0]}
                    {...props}
                  ></YoutubeDetails>
                </div>
              </div>

              <div
                className="col-xl-4 col-md-5 halfmax"
                style={{ background: "var(--iq-rgba-second-body)" }}
              >
                <YoutubeList
                  header={true}
                  app={props.match.params.AppId}
                  {...props}
                ></YoutubeList>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="mt-2">
        

         
        </div> */}
      </div>
    );
  } else {
    if (loading) {
      return (
        <div style={{ minHeight: "400px" }}>
          <CarouselContentLoader />
        </div>
      );
    } else {
      return (
        <div style={{ minHeight: "500px" }}>
          <NotFound
            code={"404"}
            message={t("label_404_VIDEO")}
            {...props}
          ></NotFound>
        </div>
      );
    }
  }
};

export default Detail;
